import { PrivateAxiosInstance } from '@/api/axios'
import { endPoint } from '@/constant/end-point'

export async function revokeCurrentServerSession(): Promise<void> {
  await PrivateAxiosInstance.post(endPoint.logout)
}

export async function revokeOtherServerSessions(): Promise<void> {
  await PrivateAxiosInstance.delete(endPoint.sessions)
}

export async function revokeServerSessionById(sessionId: string): Promise<void> {
  await PrivateAxiosInstance.delete(`${endPoint.sessions}/${sessionId}`)
}
